import {Component, computed, inject, input, output} from '@angular/core';
import {Dropdown} from '../dropdown/dropdown';
import {PartySelect, PartyType} from '../../../api';
import {PartyResource} from '../../../api/resources';
import {MultiDropdown} from '../multi-dropdown/multi-dropdown';
import {ElciaIcon} from '../icon/icon';
import {TranslatePipe} from '@ngx-translate/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'elcia-party-dropdown',
  imports: [
    Dropdown,
    MultiDropdown,
    ElciaIcon,
    TranslatePipe,
  ],
  templateUrl: './party-dropdown.html',
  styleUrl: './party-dropdown.scss',
})
export class PartyDropdown {
  protected readonly PartyType = PartyType;
  partyTypes = input.required<PartyType[]>();
  partyResourceService = inject(PartyResource);
  partyGetResource = this.partyResourceService.getParties(this.partyTypes);
  items = computed(() => this.partyGetResource.value()?.parties || []);
  control = input.required<FormControl>();
  isMulti = input<boolean>(false);
  label = input<string>();
  partySelected = output<PartySelect>();

  protected onSelectionChange(value: unknown) {
    const party = this.items().find(p => p.id === value);
    if (party) this.partySelected.emit(party);
  }
}